<template>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
    <template v-slot:send_status_text="{ record }">
      <p v-if="record.send_status==2">{{record.send_status_text}} <a-tooltip placement='right'>
      <template #title>{{record.return_msg}}
      </template>
      <ExclamationCircleOutlined class="s_c376" />
    </a-tooltip> </p>
      <p v-else>{{record.send_status_text}}</p>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
    :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"  />
</template>

<script>
  import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getBonusSendList } from "@/api/red";
  import { iscode } from "@/utils/app";
  import store from "@/store";
  // 初始化默认筛选项数值
  let defSearch = {
    page: 1,
    limit: 5,
    member_id:''
  };
  export default {
    name: "redLog",
    components: {ExclamationCircleOutlined},
    props: {
      id:{
        type:Number
      }
    },
    setup(props, { emit }) {
      // // 初始化 分页信息和筛选项信息
      let search = ref({ ...defSearch });
      // 列表数据和列头配置
      let data = ref([]);
      const state = reactive({
        listLoading: false,
        total: 1,
        time:[]
      });
      let columns = [
        {
          title: "红包类型",
          dataIndex: "bonus_type_text",
          key: "bonus_type_text"
        },
        {
          title: "红包金额",
          dataIndex: "bonus_amount",
          key: "bonus_amount",
        },
        {
          title: "红包ID",
          dataIndex: "bonus_id",
          key: "bonus_id",
        },
        {
          title: "发放状态",
          dataIndex: "send_status_text",
          key: "send_status_text",
          slots: { customRender: "send_status_text" },
        },
        {
          title: "发放渠道",
          dataIndex: "send_apply_text",
          key: "send_apply_text",
        },
        {
          title: "最近状态更新时间",
          dataIndex: "update_time",
          key: "update_time",
        },
      ];
      const $router = inject('$router')
      const $Modal = inject('$Modal')
      const _lodash = inject("_lodash");

      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      const initData = async (values) => {
        state.listLoading = true;
        try {
          let res = await getBonusSendList({...values,member_id:props.id}).then(res => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            data.value = res.data.data;
            state.total = res.data.total;
          } else {
            message.error(res.msg);
          }
        } catch (e) {
          state.listLoading = false;
        }
      };
      onMounted(() => {
        initData(search.value);
      });
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
      };
    },
  };
</script>